import React, { useEffect, useState } from 'react';
import {
  checkClientVersion,
  isClientUpdateRequired,
  UPDATE_EVENT,
} from '../utils/clientVersion';
import './ClientVersionNotice.css';

export default function ClientVersionNotice() {
  const [outdated, setOutdated] = useState(isClientUpdateRequired);

  useEffect(() => {
    const showNotice = () => setOutdated(true);
    const check = () => {
      if (!document.hidden) void checkClientVersion();
    };
    window.addEventListener(UPDATE_EVENT, showNotice);
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', check);
    const timer = window.setInterval(check, 5 * 60 * 1000);
    check();
    return () => {
      window.removeEventListener(UPDATE_EVENT, showNotice);
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', check);
      window.clearInterval(timer);
    };
  }, []);

  if (!outdated) return null;

  const reload = () => {
    if (window.confirm('Usendte endringer i skjemaet kan gå tapt. Oppdater siden nå?')) {
      window.location.reload();
    }
  };

  return (
    <aside className="client-version-notice" role="alert">
      <strong>Ny versjon av skjemaet er klar</strong>
      <p>Oppdater siden før du sender bestillingen. Ta vare på påbegynt arbeid først.</p>
      <button type="button" onClick={reload}>Oppdater siden</button>
    </aside>
  );
}
